import styled from 'styled-components';

// Mirrors .prs-dialog (Prose v1.5) — full-viewport overlay that centers the box.
// We render with a FocusTrap-wrapped div instead of the native <dialog>, so the
// :host-state selectors (`[open]`, `::backdrop`) and the prs-dialog-close /
// prs-dialog-bordered / animation pieces from the canonical CSS are dropped.
export const PrsDialog = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: center;
  background-color: rgb(var(--prs-dialog-backdrop));
  overscroll-behavior: contain;
`;

// .prs-dialog-box — square corners, prs-shadow-2xl, 32rem max width.
export const PrsDialogBox = styled.div`
  width: 91.666667%;
  max-width: 32rem;
  max-height: calc(100vh - 5em);
  background-color: var(--prs-c-white);
  border-radius: 0;
  box-shadow: var(--prs-shadow-2xl);
  overflow-y: auto;
  overscroll-behavior: contain;
  font-family: var(--prs-ff-sans);
`;

// .prs-dialog-body — content well; this dialog has no separate header so the
// title lives here as an h2 (heading-lg) followed by ui-md body.
export const PrsDialogBody = styled.div`
  padding: 1.5rem 1.5rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const PrsDialogHeading = styled.h2`
  margin: 0;
  font-weight: var(--prs-fw-heading-lg);
  font-size: var(--prs-fz-heading-lg);
  line-height: var(--prs-fl-heading-lg);
  color: var(--prs-c-gray-950);
`;

export const PrsDialogText = styled.p`
  margin: 0;
  font-weight: var(--prs-fw-ui-md);
  font-size: var(--prs-fz-ui-md);
  line-height: var(--prs-fl-ui-md);
  color: var(--prs-c-gray-950);
`;

// .prs-dialog-action — right-aligned button row.
export const PrsDialogAction = styled.div`
  margin-top: 0.5rem;
  padding: 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  background-color: var(--prs-c-white);
`;
